import { render, staticRenderFns } from "./occupation.vue?vue&type=template&id=dd240148&scoped=true"
import script from "./occupation.vue?vue&type=script&lang=js"
export * from "./occupation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd240148",
  null
  
)

export default component.exports